import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "control", "rules", "defaultValue", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { JoveFormErrorInfoView } from '../form/JoveFormErrorInfoView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveCMSRadioGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      options = props.options,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      error = props.error,
      errMessage = props.errMessage,
      _props$activeColor = props.activeColor,
      activeColor = _props$activeColor === void 0 ? 'bg-[#0E35D1]' : _props$activeColor,
      disabled = props.disabled;

  var _useState = useState(defaultValue),
      selectValue = _useState[0],
      setSelectValue = _useState[1];
  /**
   * methods
   */


  var valueChangeAction = function valueChangeAction(value) {
    setSelectValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsx(RadioGroup, {
      value: value === undefined ? selectValue : value || '',
      className: clsx('flex flex-row flex-wrap space-x-4'),
      disabled: disabled,
      children: options.map(function (option) {
        return /*#__PURE__*/_jsx(RadioGroup.Option, {
          value: option.value,
          "data-for": "main",
          "data-iscapture": "true",
          onClick: function onClick() {
            return valueChangeAction(option.value);
          },
          className: function className(_ref) {
            var checked = _ref.checked,
                active = _ref.active;
            return clsx('mb-4 flex items-center space-x-2 rounded-md border-2 px-4 py-2 transition-colors hover:bg-neutral-100', {
              'border-black bg-neutral-100': checked,
              'border-neutral-200': !checked
            }, disabled ? 'cursor-not-allowed' : 'cursor-pointer');
          },
          children: function children(_ref2) {
            var active = _ref2.active,
                checked = _ref2.checked;
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: clsx('h-4 w-4 rounded-full border-2 border-gray-300', checked ? activeColor : 'bg-white')
              }), /*#__PURE__*/_jsx("p", {
                className: "text-center text-base font-semibold text-gray-700",
                children: option.label
              })]
            });
          }
        }, option.label);
      })
    }), /*#__PURE__*/_jsx(JoveFormErrorInfoView, {
      error: error,
      errMessage: errMessage
    })]
  });
});
export var JoveCMSRadioGroupControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var onChangeAction = function onChangeAction(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(e);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsx(JoveCMSRadioGroup, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      valueChange: onChangeAction,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveCMSRadioGroup;